import WarningButton from './WarningButton';

export default WarningButton;
